import {
  FETCH_EXPIRY_DATES_REQUEST,
  FETCH_EXPIRY_DATES_SUCCESS,
  FETCH_EXPIRY_DATES_FAILURE,
  FETCH_EXPIRY_DATES_RESET,
  UPDATE_EXPIRY_DATE,
} from '../../constants/ActionTypes';

const expiryDates = (
  state = { data: {}, date: undefined, isFetching: false, errors: {} },
  action
) => {
  switch (action.type) {
    case FETCH_EXPIRY_DATES_REQUEST:
      return { ...state, data: {}, isFetching: true, errors: {} };
    case FETCH_EXPIRY_DATES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errors: {},
        data: action.data.data,
      };
    case FETCH_EXPIRY_DATES_FAILURE:
      return {
        ...state,
        data: {},
        isFetching: false,
        errors: action.error,
      };
    case UPDATE_EXPIRY_DATE:
      return { ...state, date: action.value };
    case FETCH_EXPIRY_DATES_RESET:
      return {
        ...state,
        data: {},
        isFetching: false,
        errors: {},
        date: undefined,
      };
    default:
      return state;
  }
};

export default expiryDates;
